import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
// import fron from "../../../font/Poppins-Regular.ttf";
import moment from "moment";
Font.register({
  family: "Poppins-Regular",
  src: "https://dev-gainxadmin.s3.ap-south-1.amazonaws.com/Font/Poppins-Regular.ttf",
});
const styles = StyleSheet.create({
  tbl: {
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 0 0 0",
    padding: 0,
  },
  tableHeader: {
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 0 0 0",
    padding: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    border: "1px solid #f1f1f1",
    backgroundColor: "#f1f1f1",
    minHeight: 30,
    maxHeight: 60,
  },
  tableHeaderDates: {
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 0 0 0",
    padding: 0,
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "9px",
  },
  row: {
    display: "flex",
    flexWrap: "nowrap",
    padding: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    border: "1px solid #f1f1f1",
    minHeight: 30,
    maxHeight: 60,
  },
  cell: {
    padding: "5px 5px",
    fontFamily: "Poppins-Regular",
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "100px",
    flexWrap: "wrap",
    width: "100px",
    wordBreak: "break-all",
  },
  firstCell: {
    padding: "5px 5px",
    flexGrow: 1,
    flexShrink: 2,
    fontSize: "9px",
    flexBasis: "160px",
    width: "160px",
    fontFamily: "Poppins-Regular",
  },
  indexCell: {
    padding: "5px 5px",
    flexGrow: 1,
    flexShrink: 1,
    fontSize: "9px",
    flexBasis: "10px",
    wordBreak: "break-all",
    width: "15px",
    fontFamily: "Poppins-Regular",
    backgroundColor: "#f1f1f1",
    alignItems: "center",
  },
  indexCell1: {
    padding: "8px 8px",
    flexGrow: 1,
    flexShrink: 1,
    fontSize: "9px",
    flexBasis: "10px",
    wordBreak: "break-all",
    width: "15px",
    fontFamily: "Poppins-Regular",
    backgroundColor: "#f1f1f1",
    alignItems: "center",
  },
  imageCell: {
    padding: "5px 5px",
    fontFamily: "Poppins-Regular",
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "50px",
    flexWrap: "wrap",
    width: "50px",
    wordBreak: "break-all",
  },
  header: {
    padding: 15,
    marginBottom: 15,
  },
  mainText: {
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "Poppins-Regular",
    marginTop: "15px",
    textAlign: "center",
  },
  subText: {
    fontSize: 12,
    marginTop: 5,
    textAlign: "center",
    fontFamily: "Poppins-Regular",
  },
  footer: {
    margin: 10,
    padding: 10,
    fontSize: 10,
    textAlign: "center",
    borderTopWidth: 1,
    borderColor: "#000",
    fontFamily: "Poppins-Regular",
  },
});
const Footer = () => (
  <View style={styles.footer}>
    <Text>
      Generated At {moment(new Date()).format("DD MMM YYYY")} From Criminal
      Monitoring Intelligent System
    </Text>
  </View>
);
export const Document9 = (props) => (
  console.log("props report", props?.report_name),
  console.log("props?.rows[0]?.districtName", props?.rows[0]?.districtName),
  (
    <Document>
      <Page size="A4" wrap>
        <View style={styles.header}>
          <View>
            <Text style={styles.mainText}>
              घटक: {props?.cityName}
              {props?.user === "2" && <>({props?.rows[0]?.districtName})</>}
            </Text>
            <Text style={styles.subText}>{props?.report_name}</Text>
          </View>
          <View style={styles.tableHeaderDates}>
            <Text style={{ fontSize: "14px", marginBottom: 8 }}>
              {props.filterDate?.startDate &&
                "From: " +
                  moment(props.filterDate.startDate).format("DD-MM-YYYY")}
            </Text>
            <Text style={{ fontSize: "14px", marginBottom: 8 }}>
              {props.filterDate
                ? "To: " +
                  moment(props.filterDate && props.filterDate.endDate).format(
                    "DD-MM-YYYY"
                  )
                : null}
            </Text>
          </View>
        </View>
        <View style={styles.tbl}>
          <View style={styles.tableHeader}>
            <Text style={styles.cell}>अ.क्र.</Text>
            <Text style={styles.cell}>आरोपीचे नाव</Text>
            <Text style={styles.cell}>वय</Text>
            {props?.report_name != "हिस्ट्रीशिटर - यादी" && (
              <Text style={styles.cell}>पत्ता</Text>
            )}
            <Text style={styles.cell}>आरोपीचे पोलिस ठाणे</Text>
            <Text style={styles.cell}>एकुण गुन्हे</Text>
            <Text style={styles.cell}>फोटो</Text>
          </View>
        </View>
        {props &&
          props.rows &&
          props.rows.map((item, index) => (
            <View key={index} style={styles.row} wrap={false}>
              <Text style={styles.cell}>{index + 1}</Text>
              <Text style={styles.cell}>{item.name}</Text>
              <Text style={styles.cell}>{item.age}</Text>
              {props?.report_name != "हिस्ट्रीशिटर - यादी" && (
                <Text style={styles.cell}>{item.address}</Text>
              )}
              <Text style={styles.cell}>
                {item?.districtName ? item?.districtName : item.address}
              </Text>
              <Text style={styles.cell}>
                {item.totalCrimeCount ? item.totalCrimeCount : item?.gunhaCount}
              </Text>
              <Text style={styles.cell}>
                {(item.photo && item.photo.some((p) => p.trim() !== "")) ||
                (item.photos && item.photos.some((p) => p.trim() !== ""))
                  ? "हो"
                  : "नाही"}
              </Text>
            </View>
          ))}
        <Footer />
      </Page>
    </Document>
  )
);
export const DocumentCount = (props) => (
  <Document>
    <Page size="A4" wrap>
      <View style={styles.header}>
        <View>
          <Text style={styles.mainText}>घटक: {props?.cityName}</Text>
          <Text style={styles.subText}>{props?.report_name}</Text>
        </View>
        <View style={styles.tableHeaderDates}>
          <Text style={{ fontSize: "14px", marginBottom: 8 }}>
            {props.filterDate
              ? "From: " +
                moment(props.filterDate && props.filterDate.startDate).format(
                  "DD-MM-YYYY"
                )
              : null}
          </Text>
          <Text style={{ fontSize: "14px", marginBottom: 8 }}>
            {props.filterDate
              ? "To: " +
                moment(props.filterDate && props.filterDate.endDate).format(
                  "DD-MM-YYYY"
                )
              : null}
          </Text>
        </View>
      </View>
      <View style={styles.tbl}>
        <View style={styles.tableHeader}>
          <Text style={styles.indexCell}>अ.क्र.</Text>
          <Text style={styles.cell}>गुन्ह्याचे पोलिस ठाणे</Text>
          <Text style={styles.cell}>शरीराविषयक</Text>
          <Text style={styles.cell}>मालाविषयक</Text>
          <Text style={styles.cell}>अवैध वाळू विषयक</Text>
          <Text style={styles.cell}>अवैध दारु विषयक</Text>
          <Text style={styles.cell}>जुगारविषयक</Text>
          <Text style={styles.cell}>भाग - ६</Text>
          <Text style={styles.cell}>इतर</Text>
          <Text style={styles.cell}>एकुण</Text>
        </View>
      </View>
      {props &&
        props.rows &&
        props.rows.map((item, index) => (
          <View key={index} style={styles.row} wrap={false}>
            <Text style={styles.indexCell}>{index + 1}</Text>
            <Text style={styles.cell}>{item.districtName}</Text>
            <Text style={styles.cell}>{item.शरीराविषयक}</Text>
            <Text style={styles.cell}>{item.मालाविषयक}</Text>
            <Text style={styles.imageCell}>{item["अवैध वाळू विषयक"]}</Text>
            <Text style={styles.imageCell}>{item["अवैध दारु विषयक"]}</Text>
            <Text style={styles.cell}>{item.जुगारविषयक}</Text>
            <Text style={styles.cell}>{item["भाग - ६"]}</Text>
            <Text style={styles.cell}>{item.इतर}</Text>
            <Text style={styles.cell}>{item.एकुण}</Text>
          </View>
        ))}
      <Footer />
    </Page>
  </Document>
);
export const DocumentCount1 = (props) => (
  console.log("props report", props),
  (
    <Document>
      <Page size="A4" wrap>
        <View style={styles.header}>
          <View>
            <Text style={styles.mainText}>
              घटक: {props?.cityName}
              {props?.user === "2" && <>({props?.rows[0]?.districtName})</>}
            </Text>
            <Text style={styles.subText}>{props?.report_name}</Text>
          </View>
          <View style={styles.tableHeaderDates}>
            <Text style={{ fontSize: "14px", marginBottom: 8 }}>
              {props.filterDate
                ? "From: " +
                  moment(props.filterDate && props.filterDate.startDate).format(
                    "DD-MM-YYYY"
                  )
                : null}
            </Text>
            <Text style={{ fontSize: "14px", marginBottom: 8 }}>
              {props.filterDate
                ? "To: " +
                  moment(props.filterDate && props.filterDate.endDate).format(
                    "DD-MM-YYYY"
                  )
                : null}
            </Text>
          </View>
        </View>
        <View style={styles.tbl}>
          <View style={styles.tableHeader}>
            <Text style={styles.indexCell}>अ.क्र.</Text>
            <Text style={styles.cell}>गुन्ह्याचे पोलिस ठाणे</Text>
            <Text style={styles.cell}>एकुण गुन्हे</Text>
          </View>
        </View>
        {props &&
          props.rows &&
          props.rows.map((item, index) => (
            <View key={index} style={styles.row} wrap={false}>
              <Text style={styles.indexCell}>{index + 1}</Text>
              <Text style={styles.cell}>{item.districtName}</Text>
              <Text style={styles.cell}>
                {item?.crimeCount ? item.crimeCount : item?.Count_district}
              </Text>
            </View>
          ))}
        <Footer />
      </Page>
    </Document>
  )
);
